import { parseBool } from '@/utils/parse-functions';

export default [
	{
		path: 'reports/view/:id',
		name: 'view-report',
		meta: {
			pageTitle: 'View Report',
			desktopOptimized: true
		},
		props: route => ({
			companyId: parseInt(route.params.companyid),
			id: parseInt(route.params.id),
			newReport: route.params.newReport,
			errorCode: route.query.ec && parseInt(route.query.ec),
			delaySeconds: route.query.ds && parseInt(route.query.ds),
			offlineOnly: route.query.oo && parseBool(route.query.oo),
			queryReportKey: route.query.rk
		}),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "viewReport" */ '@/sections/report-generator/view-report/view-report-page.vue'
			)
	}
];
